<template>
    <div>
        <div>
            <ul>
                <li>
                    <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="dialogVisible = true"
                    >创建
                    </el-button>
                </li>
            </ul>
        </div>

        <el-table :data="tableData" border stripe max-height="700">
            <el-table-column prop="id" label="ID" width="270px"></el-table-column>
            <el-table-column label="变量名称">
                <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="变量标识">
                <template slot-scope="scope">
                    <span>{{ scope.row.key }}</span>
                </template>
            </el-table-column>
            <el-table-column label="变量值">
                <template slot-scope="scope">
                    <span>{{ scope.row.value }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('m.operation')" width="220px">
                <template slot-scope="scope">
                    <el-button plain size="mini" type="warning" @click="handleEdit(scope.row)" circle>
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button plain size="mini" type="danger" @click="handleDelete(scope.row.id)" circle>
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
                title="分组"
                :visible.sync="dialogVisible"
        >
            <!--<el-input class="input-new-tag" v-model="inputValue"size="small" ></el-input>-->
            <div style="display: flex;flex-direction: column">
                <my-input
                        label="变量名称"
                        :nullable="false"
                        width= '800px'
                        v-model="detail.name"
                ></my-input>
                <my-input
                        label="变量标识"
                        :nullable="false"
                        width= '800px'
                        v-model="detail.key"
                ></my-input>
                <my-input
                        label="变量值"
                        :nullable="false"
                        width= '800px'
                        v-model="detail.value"
                ></my-input>
            </div>

            <span
                    slot="footer"
                    class="dialog-footer"
            >
                  <el-button @click="dialogVisible = false">取消</el-button>
                  <el-button
                          type="primary"
                          @click="dialogVisible = false;createGroup()"
                  >保存</el-button>
                </span>
        </el-dialog>

    </div>
</template>

<script>

    export default {
        name: "system",
        data() {
            return {
                dialogVisible: false,
                tableData: [],
                id:null,
                detail: {
                    name: null,
                    key: null,
                    value: null,
                }
            }
        },
        methods: {
            getAllSource() {
                this.axios.post("/system/getAll/").then((response) => {
                    this.tableData = response.data
                }).catch((error) => {
                    // this.$message.error("Query all ")
                })
            },
            handleEdit(item) {
                this.dialogVisible = true;
                this.detail = item;
                this.id = item.id;
            },
            handleDelete(id) {
                this.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.post("/system/delete/" + id)
                        .then((response) => {
                            this.$message.success("删除成功");
                            this.getAllSource()
                        }).catch((error) => {
                            this.$message.error("删除失败")
                        })
                });
            },
            createGroup() {
                if (this.detail.name == null|| this.detail.key == null|| this.detail.value == null) {
                    this.$message.error("必填项未填");
                    return
                }
                let url = '';
                if(this.id){
                    url = '/system/update/'+this.id;
                }else{
                    url = '/system/create/';
                }
                this.axios.post(url, this.detail).then((response) => {
                    this.getAllSource()
                }).catch((error) => {
                    // console.log(error.response);
                    // this.$message.error(error.response.data.message)
                })
            },
        },
        created() {
            this.getAllSource()
        },
    }
</script>

<style scoped lang="scss">
    .my > > > .el-textarea__inner {
        font-family: 'Consolas', Helvetica, Arial, sans-serif;
        /*font-size: 18px;*/
    }

    ul {
        margin-bottom: 10px;
        li {
            display: inline-block;
            margin-right: 10px;
        }
    }

    .el-button--primary {
        color: #fff;
        background-color: #08245E;
        border-color: #08245E;
    }

    .el-button--primary:hover {
        background: rgba(8,36,94,0.8);
        border-color: rgba(8,36,94,0.8);
    }

    .el-table__body tr{
        font-size: 14px!important;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #ffffff!important;
    }
    .el-table__body tr:hover > td{
        background-color:yellow !important;
    }
</style>
